import { RegionFilter as AntdRegion } from "@empglabs/backoffice-ui-kit"

const RegionFilter = props => {
  return <AntdRegion {...props} />
}

export default RegionFilter
